import { Switch } from "react-router-dom"
import { createRoutes } from "../lib/core/routing/utils"

// Init legacy modules.
const modules = [
  require("content/assessment/module").default,
  require("assessments/show/module").default
]

modules.forEach((module) =>
  module && typeof module.start === "function" ? module.start() : undefined
)

// Init related stores.
require("library/show/resource-store")
require("library/register/register-store")
require("library/admin/content-admin-store")
require("path/stores/path-admin-store")
require("path/stores/path-store")
require("path/stores/path-analytics-store")
require("path/stores/step-store")
require("step/stores/step-downloads-admin-store")
require("step/completion/stores/step-completion-store")
require("note/note-store")
require("message/store/message-store")
require("member/store/member-store")

// Necessary for legacy/web CompletionFeedbackPreview to render assessment
// TODO: maybe chunk code related to legacy step content?
// NOTE: requiring after stores are initailized, though likely not necessary.
window.AssessmentSubmissionPreview =
  require("../completion/AssessmentSubmissionPreview").default

const routes = createRoutes([
  require("library/store/routes").default,
  require("library/register/routes").default,
  require("library/show/components/path/routes").default,
  require("library/show/components/publish/routes").default,
  require("library/show/components/path/sync-routes").default,
  require("library/show/resource-trailer-routes").default,
  require("library/library-routes").default,
  require("library/order-routes").registrationRoute,
  require("library/order-routes").groupLicenseRoute,
  require("library/order-routes").autoRegisterRoute,
  require("library/features-routes").default,
  require("library/invite-routes").default,
  require("license/routes").default,
  require("analytics/routes").default,
  require("member/routes").default,
  require("message/routes").default,
  require("step/components/manage/routes").default,
  require("step/components/manage/schedule-routes").default,
  require("library/show/routes").default
])

const Routes = () => <Switch>{routes}</Switch>

// Attempting to render something like {LibraryRoutes.routes} does not
// tell React to lazily load the LibraryRoutes chunk, so currently must
// use LibraryRoutes as <LibraryRoutes />.
// Routes.routes = routes

export default Routes
